import { BrowserRouter } from 'react-router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from '@mui/material/styles';
import AppRoutes from '@/routes/AppRoutes';
import { theme } from '@/theme';
import { NewAuthProvider } from '@/providers/AuthProvider/NewAuthProvider';
import { ApiProvider } from '@/providers/ApiContextProvider/ApiContextProvider';
import { PermissionDeniedProvider } from '@/providers/PermissionDeniedProvider/PermissionDeniedContextProvider';
import { EntitiesListProvider } from '@/providers/EntitiesListContextProvider/EntitiesListContextProvider';
import { NewFeatureProvider } from '@/providers/NewFeatureContextProvider/NewFeatureContextProvider';
import { BreakpointsProvider } from '@/providers/BreakpointsProvider/BreakpointsContextProvider';

export const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <NewAuthProvider>
        <PermissionDeniedProvider>
          <ApiProvider>
            <NewFeatureProvider>
              <EntitiesListProvider>
                <ThemeProvider theme={theme}>
                  <BreakpointsProvider>
                    <AppRoutes />
                  </BreakpointsProvider>
                </ThemeProvider>
              </EntitiesListProvider>
            </NewFeatureProvider>
          </ApiProvider>
        </PermissionDeniedProvider>
      </NewAuthProvider>
    </BrowserRouter>
  </QueryClientProvider>
);

export default App;
